import React from 'react';

const ValueProp = () => {
  const values = [
    {
      title: 'Local Expertise',
      description: 'Tailored solutions for Kenya’s healthcare challenges, extending to Africa.',
    },
    {
      title: 'Cutting-Edge Tech',
      description: 'AI, cloud, and mobile tools for surveillance and informatics.',
    },
    {
      title: 'End-to-End Support',
      description: 'From platform building to training and data analysis.',
    },
    {
      title: 'Scalable & Future-Proof',
      description: 'Hub for publications, activities, and collaborations.',
    },
  ];

  return (
    <section className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-blue-800">Why Our Digital Health Hub?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center p-6 bg-white rounded-xl shadow-md transition-all hover:shadow-lg hover:-translate-y-1">
              <h3 className="text-xl font-semibold mb-2 text-teal-600">{value.title}</h3>
              <p className="text-gray-600">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProp;